export default __webpack_public_path__ + "static/media/GLTitleImage.71b91c3b.jpg";